export const Api = {
  list_historic_data: (from?: number, to?: number) => new Array(23).fill(0).map(() => ({
    id: Math.random().toString(36).substring(7),
    date: Date.now() - 1000 * 60 * 60 * 24 * 3,
    label: 'OEE Linea',
    value: 0.78,
    workstation: 'SOLDERING LINE X400-FZ',
    unit: '%',
  })) as Parameter[],

  // sono solo readonly
  set_note_on_parameter: (id: string, note: string) => {
    alert(`Setting note "${note}" on parameter ${id}`);
  },
}


export type WorkStatus = 'running' | 'error' | 'warning' | 'standby' | string;


export type Parameter = {
  id: string;
  label: string;
  value: number;
  date: number;
  workstation: string;
  unit?: string;
  notes?: string;
};
